"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("./styles"));
var _icons = require("@material-ui/icons");
var _core = require("@material-ui/core");
var _Page = _interopRequireDefault(require("../../api/Page"));
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
var _Auth = require("../../contexts/Auth");
var _Theme = require("../../contexts/Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ReaderNavigation(_ref) {
  var {
    pdf,
    className
  } = _ref;
  var {
    auth
  } = (0, _Auth.useAuth)();
  var trackService = (0, _Trackings.default)(auth);
  var {
    applicationToken,
    sessionToken,
    uuid,
    userId
  } = auth;
  var [currentPage, setCurrentPage] = (0, _react.useState)();
  var currentPageRef = (0, _react.useRef)();
  var [totalPages, setTotalPages] = (0, _react.useState)();
  var {
    theme
  } = (0, _Theme.useTheme)();
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    if (!pdf) return;
    setCurrentPage(pdf.viewer.currentPageNumber);
    setTotalPages(pdf.props.pdfDocument.numPages);
    var onScroll = () => setCurrentPage(pdf.viewer.currentPageNumber);
    pdf.viewer.container.addEventListener('scroll', onScroll);
    return () => pdf.viewer.container.removeEventListener('scroll', onScroll);
  }, [pdf]);
  (0, _react.useEffect)(() => {
    if (currentPageRef.current === currentPage) return;
    trackService.trackPageView({
      currentPage: currentPage
    });
    _Page.default.setPage(applicationToken, sessionToken, uuid, userId, {
      page: String(currentPage)
    });
    currentPageRef.current = currentPage;
  }, [currentPage, applicationToken, uuid, sessionToken, trackService, userId]);
  function goToPage(func) {
    pdf.viewer.currentPageNumber = func(pdf.viewer.currentPageNumber);
  }
  function getPagePercent() {
    return parseInt(100 * currentPage / totalPages);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.wrapper, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.iconBtn,
    onClick: () => goToPage(page => page - 1),
    disabled: !pdf
  }, /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowLeft, {
    className: classes.arrowIcon,
    style: {
      color: theme.reader.color
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.pages,
    style: {
      color: theme.reader.color
    }
  }, pdf ? "".concat(currentPage, " / ").concat(totalPages, " (").concat(getPagePercent(), "%)") : 'Carregando...'), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.iconBtn,
    onClick: () => goToPage(page => page + 1),
    disabled: !pdf
  }, /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowRight, {
    className: classes.arrowIcon,
    style: {
      color: theme.reader.color
    }
  })));
}
ReaderNavigation.propTypes = {
  pdf: _propTypes.default.object
};
var _default = exports.default = ReaderNavigation;